import i18next from 'i18next';

export const init = (translation: object): void => {
  i18next.init({
    lng: 'ja',
    resources: {
      ja: {
        translation,
      },
    },
    // Align the prefix & suffix with Rails I18n's.
    interpolation: {
      prefix: '%{',
      suffix: '}',
    },
    parseMissingKeyHandler: (key: string) => {
      return `translation missing: ${key}`;
    },
    returnNull: false,
  });
};

export const error = (
  errorType: string,
  fieldName?: string,
  options?: object,
): string => {
  const opts = {
    ...options,
    field_name: fieldName
      ? i18next.t(`register.form.input.${fieldName}`)
      : undefined,
  };
  const key = `registration.sign_up.new.errors.${errorType}`;
  return i18next.t(key, opts);
};
